import { ProfessionalExperienceEntryType } from '../../../../Types/ProfessionalExperienceLineType';

export const schema: ProfessionalExperienceEntryType = {
	showMeOn: ['all'],
	length: '~6 Months',
	timespan: 'May 2022 - Dec 2022',
	title: 'Founder & Chief Technology Officer',
	technologies: ['ReactJS', 'React Native', 'NodeJS', 'NoSQL (DynamoDB)', 'SQL (OLAP)', 'OpenAI', 'Cypress'],
	languages: ['JavaScript', 'Typescript', 'Bash Scripting'],
	tools: ['AWS', 'Google Cloud'],
	company: 'KidiUp',
	description: "A platform to find, book, pay and keep track of children's activities all in one place",
	location: 'Toronto, Ontario',
	results: 'Aug 2022 - Demonstrated feasibility in Aurora, Ontario market',
	details: [
		{
			showMeOn: ['all'],
			entry: 'Developed core web app reducing time to enroll children in activities by 95%, central to the company’s value proposition.',
		},
		{
			entry: 'Eliminated 1,800+ hours of quarterly manual work by building an LLM-integrated web crawler to extract partner data',
			showMeOn: ['all'],
		},
		{
			entry: 'Cut fundraising target by 30% by avoiding contractor-heavy data entry workflows through intelligent automation',
			showMeOn: ['all'],
		},
		{
			showMeOn: ['all'],
			entry: '\tIncreased deployment consistency by implementing a CI/CD pipeline that automated infrastructure and app delivery',
		},
		{
			showMeOn: ['all'],
			entry: 'Enabled real-time, data-driven decision making by building a KPI tracking system tailored to evolving startup priorities',
		},
		{
			showMeOn: ['all'],
			entry: 'Improved roadmap responsiveness by leading focus groups and shaping product strategy aligned with early market signals',
		},
		{
			showMeOn: ['mentoring'],
			entry: 'Interviewed, hired, and mentored talent, ensuring code quality and team growth',
		},
		{
			showMeOn: ['marketing'],
			entry: 'Created marketing collateral and managed social media, producing engaging content, including a sketch for a fundraising application',
		},
		{
			showMeOn: ['none'],
			entry: 'Directed, produced, and co-starred in amusing 3-minute sketch for a fundraising application',
		},
	],
};
